import { ReleaseInfo } from "@pages/dashboard/types";

const GITHUB_API = "https://api.github.com/repos";

function requestJsonRaw(method: string, path: string): Promise<Response> {
  const headers = {
    Accept: "application/json",
  };

  return fetch(path, {
    method: method,
    headers,
  });
}

export const fetchLatestReleaseInfo = (
  org: string,
  repo: string
): Promise<ReleaseInfo> => {
  return requestJsonRaw(
    "GET",
    `${GITHUB_API}/${org}/${repo}/releases/latest`
  ).then((r) => {
    return r.json() as unknown as ReleaseInfo;
  });
};
